export enum FeatureToggle {
  storefrontOnboarding = 'rt_storefront_onboarding',
  OnboardingSiteSetup = 'rt_onboarding_site_setup',
  InternalUat = 'rt_internal_uat',
  LaunchPrep = 'rt_onboarding_launch_prep',
  LockAdminSetupForm = 'rt_lock_admin_setup_form',
}
